var _image;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "audio_icon",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAABmJLR0QA/wD/AP+gvaeTAAAD3klEQVR4nO3by04bVxyA8c/jsak0xvb4wgIKSZwFIXWdglBFSrur1FUqpZuqitQHYNVF8xTNqov0LRoplbropptaaaWSkMSNgyriAC2gYMOkQHzB9nTBpYooCvax53jG59taZv76ceZqG1Qqlap/87X6hq9v/2J3YxDRfPh+/WZu9qrT29Wc3mC3srFnbt7O3nN6u22vwE8/m+38NG109/ssAJrmo9m0ATt7a+6jD53avmdW4I2Px9E0H+CbdXIlegYwczF+jOjk7uwZQJCD6ClAcB7Rc4DgLKInAcE5RM8CgjOIngaE7iN6HhC6i9gXgNA9xL4BhO4g9hUgdB6x7wChs4h9CQidQ+xbQOgMot6NwWR087us8N+wsWdafU9fr8BO5PoV2Kkn40dPtltNrUDBFKBgClAwBSiYAhRMAQqmAAXr+evAW9/+SHBAR8NHyBjANEO8PWJyfixJPBaSPV7vAwLUqnUAKtV9ilu7/Lm0AeSJRQ2mJy+QvjyK5m/5WyodyRWAAFdn3qdaq7H36hXWtsX2tsWWtcdPP+dYyK3w5ReOfR3mtVwDqAcC6IEAhmEwlExi2zalUol8fpEXm//Im0vallssm71HMBDACBmY0SixWIxEIgEsSp3LNYDNZpNKtUqlWqVU2oKlZ0QiYdljuQfwq7lP2NmtsLZu8azwgsLKJi9fytt1j3INoK77MaMGZtTgnYkR9vcbPP5jld/ml9jbq8qbS9qWBQsE/Ey9d55306M8zq1Km8P1dyIB/QBSVq4HlJ0CFEwBCqYABZN+Fm40mjzMrZBfXKNY2gEgER9kYnyYK+kxydO9OamAO7sV7vzw+4l72fUNi/UNi9yTvyRNdvakATYazWO8gYEgqVQK04wCYFkWhcKy1IcEZ00a4MPcyjHe1NQkuv7fKPF4nEgkwvz9B9SqNVkjnilpJ5EnT9cASKVSr+Edpes6F1MXnB6r5aQBlrYOThhHu+3/FTVNp8Zpu56+jPEd/jI5GJR+sXBq0gDjsUHg4IRxWtuHryV64MOj05IGePnSMACFwjL1ev3E6/V6nefPlwGYuDTi6GytJA3wSnqMoWSYcrnM/P0HFItF6o0G9UaDYrHEwsIjyuUyQ8kwmfSorDHfmLSDi9+vcf3a9PG1YD5/8rONoWSY69em8Wu9e6iWenQeDL3Fjc8/4FFulfzTv9k8vJVLJsJMjA+TSY/2NB70wL2wX9OYzJxjMnNO9iht1dv/XhekAAVTgIIpQMEUoGAKUDAFKJgCFEwBCqYABVOAgilAwRSgYApQMAUoWNvPA9v9hbfXUitQpVKpVG33L9j+Vezf/5yuAAAAAElFTkSuQmCC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.cbf92b933a160f128235e6cb3c4f9bea.svg";
export { ForwardRef as ReactComponent };